import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface UserPrivileges {
	// Liste des ids d'items de menu à cacher pour cet utilisateur
	deniedMenuIds: string[];
}

@Injectable({ providedIn: 'root' })
export class PrivilegesService {
	private storageKey(userId: string | number): string {
		return `privileges:${userId}`;
	}

	getUserPrivileges(userId: string | number): Observable<UserPrivileges> {
		return of(this.getUserPrivilegesSync(userId));
	}

	getUserPrivilegesSync(userId: string | number): UserPrivileges {
		try {
			const raw = localStorage.getItem(this.storageKey(userId));
			if (!raw) { return { deniedMenuIds: [] }; }
			const parsed = JSON.parse(raw);
			return { deniedMenuIds: Array.isArray(parsed?.deniedMenuIds) ? parsed.deniedMenuIds : [] };
		} catch (_e) {
			return { deniedMenuIds: [] };
		}
	}

	saveUserPrivileges(userId: string | number, privileges: UserPrivileges): Observable<void> {
		localStorage.setItem(this.storageKey(userId), JSON.stringify({ deniedMenuIds: privileges.deniedMenuIds || [] }));
		return of(void 0);
	}
} 